import Screen from '../../components/screen';

export default function PrivacyPolicies() {
	return (
		<Screen hideFooter>
			<div>Politica de privacidade</div>
		</Screen>
	);
}